export enum DOCUMENTS_SIGN_IN_MODAL_TITLE_ENUM {
    SELECT_SIGN_IN = 'selectSign',
    CONSFIRM_TEXT = 'confirmText',
    ECP_ANIMATION = 'ecpAnimation',
    FINISH = 'finish',
};
